import React from 'react'
import AppleStoreBadgeEn from '../images/download_on_the_app_store_badge_en.svg'
import AppleStoreBadgeNl from '../images/download_on_the_app_store_badge_nl.svg'
import AppleStoreBadgeFi from '../images/download_on_the_app_store_badge_fi.svg'
import GooglePlayBadgeNl from '../images/get_it_on_google_play_badge_web_color_nl.svg'
import GooglePlayBadgeEn from '../images/get_it_on_google_play_badge_web_color_en.svg'
import GooglePlayBadgeFi from '../images/get_it_on_google_play_badge_web_color_fi.png'
import FeatureFlag, { PLAY_STORE_LINKS_FLAG } from 'components/feature_flags/FeatureFlag'
import { localized } from 'components/common/Locales'

// Official store badges per locale; locales without their own badge get the English one.
const appleStoreBadges = { nl: AppleStoreBadgeNl, en: AppleStoreBadgeEn, fi: AppleStoreBadgeFi }
const googlePlayBadges = { nl: GooglePlayBadgeNl, en: GooglePlayBadgeEn, fi: GooglePlayBadgeFi }

const NativeAppStoreLinks = () => {
  const appleStoreBadge = localized(appleStoreBadges)
  const googlePlayBadge = localized(googlePlayBadges)

  const appleStoreUrl = process.env.NATIVE_APP_APPLE_STORE_URL
  const googlePlayUrl = process.env.NATIVE_APP_GOOGLE_PLAY_URL

  return (
    <div className='native-app-store-links'>
      <a href={appleStoreUrl} target='_blank' rel='noopener noreferrer' className='store-badge apple-store'>
        <img src={appleStoreBadge} alt='App Store' />
      </a>
      <FeatureFlag name={PLAY_STORE_LINKS_FLAG}>
        <a href={googlePlayUrl} target='_blank' rel='noopener noreferrer' className='store-badge-google google-play'>
          <img src={googlePlayBadge} alt='Google Play' />
        </a>
      </FeatureFlag>
    </div>
  )
}

export default NativeAppStoreLinks
